var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-form",class:{ 'button-form-red': _vm.danger },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('handleClick')}}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }